import { signal } from '@preact/signals'
import {
  addLineItemsHandler,
  clearCartHandler,
  getCartHandler,
  updateCartHandler,
  updateLineItemHandler
} from '../cart-api'
import { Cart } from '../types'
import CartStore, { CartResult } from './cart-store'
export {
  applyDiscountCodes,
  getDonationCategory,
  onAddLineItems,
  onBeforeCheckout,
  onCartError,
  onClearCart,
  onUpdateCart,
  onUpdateLineItem,
  setRootRoute
} from '../cart-store-legacy'

export const cartStore = new CartStore({
  addLineItems: addLineItemsHandler,
  clearCart: clearCartHandler,
  getCart: getCartHandler,
  updateCart: updateCartHandler,
  updateLineItem: updateLineItemHandler
})

const cartState = signal<Cart | null>(null)
const errorState = signal<string | null>(null)

cartStore.addEventListener('cartUpdated', (event: CustomEvent<CartResult>) => {
  const { cart } = event.detail
  cartState.value = cart
  errorState.value = event.detail.error
})

cartStore.addEventListener('cartError', (event: CustomEvent<CartResult>) => {
  const { cart } = event.detail
  cartState.value = cart
  errorState.value = event.detail.error
})

export const getCartError = () => errorState.value

export const getCart = () => {
  if (!cartState.value) {
    void cartStore.loadCart()
  }
  return cartState.value
}

export const loadCart = cartStore.loadCart.bind(cartStore) as typeof cartStore.loadCart

export const clearCart = cartStore.clearCart.bind(cartStore) as typeof cartStore.clearCart

export const addLineItems = cartStore.addLineItems.bind(cartStore) as typeof cartStore.addLineItems

export const updateCart = cartStore.updateCart.bind(cartStore) as typeof cartStore.updateCart

export const updateLineItem = cartStore.updateLineItem.bind(
  cartStore
) as typeof cartStore.updateLineItem

export const checkout = (url?: string) => {
  cartStore.checkout(url)
  return Promise.resolve()
}

export const waitForSettle = () => cartStore.waitForSettle()
